// @ts-nocheck
import { put, takeLatest } from 'redux-saga/effects';
import { postAPIDataV3, putAPIDataV3, deleteAPIDataV3 } from 'utils/api';
import { triggerActivateUser, triggerAddUserRole, triggerCreateUser, triggerDeactivateUser, triggerRemoveUserRole, triggerDeleteUser } from './sagaActions';
import { toggleLoader } from 'models/loaders/sagaActions';
import { LOADER_COMPONENTS } from './constants';
import { getDispatch } from 'reducers';
import { triggerFetchAutoComplete } from 'models/autoComplete/sagaActions';
import { triggerNotification } from 'organisms/notifications/sagaActions';
import * as dynamicGridSagaActions from 'models/dynamicGrid/sagaActions';
import * as constants from './constants';
import { REQUESTS } from 'utils/services/thetaretail/requests';

export const handleCreateUser = async ({ payload: { userName, userEmail, componentId, roles } }) => {

	const dispatch = getDispatch();
	try {
		if (!userName) {
			return
		}
		dispatch(toggleLoader({
			componentId: LOADER_COMPONENTS.CREATE_USER,
			isLoading: true
		}));
		await postAPIDataV3({
			service: 'acl', url: 'users', body: {
				userName,
				userEmail,
				Roles: roles
			}
		});
		dispatch(triggerFetchAutoComplete({
			componentId: 'acl-all-users',
		}))
		dispatch(toggleLoader({
			componentId: LOADER_COMPONENTS.CREATE_USER,
			isLoading: false
		}));
		setTimeout(async () => {
			await dispatch(
				dynamicGridSagaActions.refreshGridData({
					tableId: constants.TABLE_ID,
				})
			);
		}, 2000);
	}
	catch (e) {
		dispatch(triggerNotification({
			message: e?.data?.message
		}))
	}

};


export const handleAddRole = async ({ payload: { userId, roles, isForced } }) => {
	try {

		const dispatch = getDispatch();

		await putAPIDataV3({
			service: 'acl', url: `users/${userId}`, body: {
				Roles: roles,
				isForced
			}
		});
		dispatch(triggerFetchAutoComplete({
			componentId: 'acl-all-users',
		}))
		setTimeout(async () => {
			await dispatch(
				dynamicGridSagaActions.refreshGridData({
					tableId: constants.TABLE_ID,
				})
			);
		}, 2000);

	}
	catch (e) {
		dispatch(triggerNotification({
			message: e?.data?.message
		}))
	}

};

export const handleRemoveRole = async ({ payload: { userId, roles } }) => {
	try {

		const dispatch = getDispatch();

		const { data } = await putAPIDataV3({
			service: 'acl', url: `users/roles/${userId}`, body: {
				Roles: roles
			}
		});
		dispatch(triggerFetchAutoComplete({
			componentId: 'acl-all-users',
		}))
	}
	catch (e) {

	}

};


export const handleDeactivateUser = async ({ payload: { userId } }) => {
	try {

		const dispatch = getDispatch();

		const { data } = await putAPIDataV3({
			service: 'acl', url: `users/state/${userId}`, body: {
				IsActive: false
			}
		});
		dispatch(triggerFetchAutoComplete({
			componentId: 'acl-all-users',
		}))
		// dispatch(triggerFetchAutoComplete({
		// 	componentId: 'acl-user-roles',
		// }))
		// dispatch(triggerFetchAutoComplete({
		// 	componentId: 'acl-all-roles',
		// }))

	}
	catch (e) {
		console.log(e)
	}

};

export const handleActivateUser = async ({ payload: { userId } }) => {
	try {

		const dispatch = getDispatch();

		const { data } = await putAPIDataV3({
			service: 'acl', url: `users/state/${userId}`, body: {
				IsActive: true
			}
		});
		dispatch(triggerFetchAutoComplete({
			componentId: 'acl-all-users',
		}))
		// dispatch(triggerFetchAutoComplete({
		// 	componentId: 'acl-user-roles',
		// }))
		// dispatch(triggerFetchAutoComplete({
		// 	componentId: 'acl-all-roles',
		// }))

	}
	catch (e) {
		console.log(e)
	}

};

export const handleDeleteUser = async ({ payload: { UserID, UserEmail } }) => {
	const dispatch = getDispatch();
	try {
		await deleteAPIDataV3({
			service: REQUESTS.DELETE.DELETE_USER.service,
			url: REQUESTS.DELETE.DELETE_USER.url,
			body: {
				UserID,
				UserEmail
			}
		});
		
		dispatch(triggerFetchAutoComplete({
			componentId: 'acl-all-users',
		}));
		
		setTimeout(async () => {
			await dispatch(
				dynamicGridSagaActions.refreshGridData({
					tableId: constants.TABLE_ID,
				})
			);
		}, 2000);
	}
	catch (e) {
		dispatch(triggerNotification({
			message: e?.data?.message || 'Failed to delete user'
		}));
		console.log(e);
	}
};




export default function* rootSaga() {
	return [
		yield (takeLatest(triggerCreateUser, handleCreateUser)),
		yield (takeLatest(triggerAddUserRole, handleAddRole)),
		yield (takeLatest(triggerRemoveUserRole, handleRemoveRole)),
		yield (takeLatest(triggerDeactivateUser, handleDeactivateUser)),
		yield (takeLatest(triggerActivateUser, handleActivateUser)),
		yield (takeLatest(triggerDeleteUser, handleDeleteUser))


	];
}